import { useState } from "react";
import { Icon } from "@/components/ui/Icon";
import { CreateClubForm } from "./CreateClubForm";

interface CreateClubCardProps {
  creatorId: string;
}

/**
 * CreateClubCard - Placeholder card for creating a new club.
 * Matches ClubCard dimensions with dashed border styling.
 */
export function CreateClubCard({ creatorId }: CreateClubCardProps) {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setDialogOpen(true)}
        className="group flex flex-col gap-4 bg-background rounded-3xl border border-border-tertiary p-2 pb-4 w-full max-w-[300px] overflow-hidden shadow-[0px_2px_8px_0px_rgba(0,0,0,0.04)] transition-shadow hover:shadow-[0px_4px_24px_0px_rgba(0,0,0,0.08)] text-left"
      >
        {/* Placeholder image area with dashed border */}
        <div className="aspect-square w-full bg-surface rounded-2xl relative overflow-hidden">
          <div className="absolute inset-0 border border-dashed border-border-tertiary rounded-2xl" />
        </div>

        {/* Card content */}
        <div className="flex-1 min-w-0 flex flex-col gap-1 px-2">
          <h3 className="text-lg font-medium text-text-primary">
            Create a club
          </h3>
          <div className="flex items-center gap-2 min-h-6 text-body-3 text-text-secondary">
            <Icon name="user-group" size={12} />
            <span>Invite your friends</span>
          </div>
        </div>
      </button>

      <CreateClubForm
        creatorId={creatorId}
        open={dialogOpen}
        onOpenChange={setDialogOpen}
      />
    </>
  );
}
